import { render, staticRenderFns } from "./TherapyAlert.vue?vue&type=template&id=da71971e&"
import script from "./TherapyAlert.vue?vue&type=script&lang=js&"
export * from "./TherapyAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports